// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CodelistItem
 */
export interface CodelistItem {
  /**
   *
   */
  key?: string | null;
  /**
   *
   */
  _default?: string | null;
  /**
   *
   */
  link?: string | null;
}

/**
 * Check if a given object implements the CodelistItem interface.
 */
export function instanceOfCodelistItem(value: object): value is CodelistItem {
  return true;
}

export function CodelistItemFromJSON(json: any): CodelistItem {
  return CodelistItemFromJSONTyped(json, false);
}

export function CodelistItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CodelistItem {
  if (json == null) {
    return json;
  }
  return {
    key: json["key"] === undefined ? undefined : json["key"] === null ? null : json["key"],
    _default:
      json["default"] === undefined ? undefined : json["default"] === null ? null : json["default"],
    link: json["link"] === undefined ? undefined : json["link"] === null ? null : json["link"],
  };
}

export function CodelistItemToJSON(json: any): CodelistItem {
  return CodelistItemToJSONTyped(json, false);
}

export function CodelistItemToJSONTyped(
  value?: CodelistItem | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    key: value["key"],
    default: value["_default"],
    link: value["link"],
  };
}
